<div class="custom_select">
  <div class="custom_select__selected" role="custom_select-informer">{% unsafe options[selectedId] | formatSelected %}</div>
  <ul class="custom_select-options" role="custom_select-modal">
    {% for id of ids %}
      <li class="custom_select-options__item{{ selectedId === id ? ' custom_select-options__item--selected' : '' }}" data-option-id="{{ id }}">
        {{ options[id] }}
      </li>
    {% endfor %}
  </ul>
</div>